<template>
  <div class="trgg" @click="toggleClick">
    <!--<svg t="1492500959545" @click="toggleClick" class="svg-icon hamburger" :class="{'is-active':isActive}" style="" viewBox="0 0 1024 1024"-->
      <!--version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1691" xmlns:xlink="http://www.w3.org/1999/xlink" width="64" height="64">-->
      <!--<path d="M966.8023 568.849776 57.196677 568.849776c-31.397081 0-56.850799-25.452695-56.850799-56.850799l0 0c0-31.397081 25.452695-56.849776 56.850799-56.849776l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.849776l0 0C1023.653099 543.397081 998.200404 568.849776 966.8023 568.849776z"-->
        <!--p-id="1692"></path>-->
      <!--<path d="M966.8023 881.527125 57.196677 881.527125c-31.397081 0-56.850799-25.452695-56.850799-56.849776l0 0c0-31.397081 25.452695-56.849776 56.850799-56.849776l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.849776l0 0C1023.653099 856.07443 998.200404 881.527125 966.8023 881.527125z"-->
        <!--p-id="1693"></path>-->
      <!--<path d="M966.8023 256.17345 57.196677 256.17345c-31.397081 0-56.850799-25.452695-56.850799-56.849776l0 0c0-31.397081 25.452695-56.850799 56.850799-56.850799l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.850799l0 0C1023.653099 230.720755 998.200404 256.17345 966.8023 256.17345z"-->
        <!--p-id="1694"></path>-->
    <!--</svg>-->
    
    <div class="trapezoid">
      <i class="back-xiangzuo" :style="{transform:`rotate(${isActive?0:180}deg)`}"></i>
    </div>
    <!-- <div class="" style="width: 6px;height: 6px;background-color: #fff;position: absolute;transform: rotate(45deg);top: 50%;left: -3px;">
      
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'hamburger',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    toggleClick: {
      type: Function,
      default: null
    }
  }
}
</script>

<style scoped>
  .trgg{
    width:20px ;
    height:40px;
    position: fixed;
    box-sizing: content-box;
    top: 40%;
    overflow: hidden;
    padding:24px 0;
  }
  .trapezoid{
    width: 16px;
    height: 40px;
    background-color: #3E475F;
    /* border-width: 15px 11px;
    border-style: solid;
    border-color: transparent transparent transparent #3E4760;
    box-sizing: content-box; */

  }
  .trgg::before,.trgg::after{
    content: '';
    width: 18px;
    height: 26px;
    position: absolute;
    background-color: #3E475F;
    z-index: 2;
    box-shadow: 1px 0 0px -0.5px #3E475F;
    border-radius: 4px;
    transition: all .3s;
  }
  .trgg::before{
    transform: skew(20deg);
    top: 0px;
    left: -6px;
  }
  .trgg::after{
    transform: skew(-20deg);
    bottom:0;
    left: -6px
  }
  .back-xiangzuo{
    color: #fff;
    transition: transform .3s;
    display: block;
  }
.hamburger {
    display: inline-block;
    cursor: pointer;
    width: 20px;
    height: 20px;
    transform: rotate(0deg);
    transition: .38s;
    transform-origin: 50% 50%;
}

.hamburger.is-active {
    transform: rotate(90deg);
}
</style>
